import { useState, useEffect, useRef } from "react";
import { TagGroup, View, Flex, Divider, TextField, Disclosure, Accordion, DisclosurePanel, DisclosureTitle, TreeViewItem, TreeViewItemContent, TreeView, Item, Text, ActionButton, ToastQueue } from "@adobe/react-spectrum";
import { useDependency } from "../../../../../contexts/DependencyProvider";
import { ListDistributionGroupRequest } from "../../../../../services/soap/main/requests/ListDistributionGroupRequest";
import { ContactFormData } from "../AddNewPerson";
import { CloseIcon, EditIcon } from "../../../../../components/protected/Icons/IconsLib";
import { Check, ExclamationTriangle, Folder } from "react-bootstrap-icons";
import { Badge, Button } from "react-bootstrap";
import styles from './DistributionGroups.module.css'
import { useTranslation } from "react-i18next";

interface IDistributedGroupsSectionProps {
  data: ContactFormData["DGroups"];
  onChange: (data: ContactFormData["DGroups"]) => void;
  expandedSectionKey:any
  setExpandedSectionKey:(data:any)=>void;
  validationErrors:any
  setValidationErrors : (data:any)=>void;
  fieldConfig:any
  validationStatus:any
  setValidationStatus:(data:any)=>void;
}

const DistributedGroupsSection: React.FC<IDistributedGroupsSectionProps> = ({ data, onChange,expandedSectionKey,setExpandedSectionKey,
  validationErrors,
  setValidationErrors,
  fieldConfig,
  validationStatus,
  setValidationStatus
 }) => {
  const { store, mainService } = useDependency();
  const [distributionGroups, setDistributionGroups] = useState<any>();
  const [dGroups,setDGroups] = useState<any[]>([]);
  const [selectedGroups, setSelectedGroups] = useState<any[]>(data);
  const [expandedSections, setExpandedSections] = useState<Set<number>>(new Set());
  const [highlightedGroupId, setHighlightedGroupId] = useState<string | null>(null);
  const [isSectionRequired,setIsSectionRequired] = useState(false);
  const { t } = useTranslation('contacts');
  const _t = (key: string) => t(`addNewCompany.${key}`, { ns: 'contacts' });
  const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
  useEffect(() => {
      if(fieldConfig?.DGROUP?.required
      ){
        setValidationStatus((prev:any) => ({ ...prev, ['groupsSection']: false }));
        setIsSectionRequired(true)
      } 
    }, [fieldConfig]);

  useEffect(() => {
    (async () => {
      try {
        let res = await mainService.listDistributionGroup(
          new ListDistributionGroupRequest(store.Server, store.SessionId)
        );
        if (res.result === "OK" && res.DGROUP.length > 0) {
          const groupedData = groupData(res.DGROUP)
        setDistributionGroups(groupedData);
        setDGroups(res.DGROUP)
        }
      } catch (error) {
        console.log("Error fetching distribution groups", error);
      }
    })();
  }, []);

  useEffect(() => {
  if (distributionGroups && data?.length > 0) {
    const enriched = data.map((group:any) => {
      if (!group.category) {
        const categoryName = findCategoryName(distributionGroups, group.id);
        return { ...group, category: categoryName || "" };
      }
      return group;
    });

    setSelectedGroups(enriched);
    onChange(enriched);
  }
}, [distributionGroups, data]);

  const findCategoryName = (groups: any[], groupId: string) => {
  for (const node of groups) {
    if (node.children) {
      const found = node.children.find((child: any) => child.key === groupId);
      if (found) return node.name;
    }
  }
  return "";
};

  const handleGroupSelection = (selectedKeys: any) => {
      const selectedGroupIds = Array.isArray(selectedKeys) ? selectedKeys : Array.from(selectedKeys || []);
      const updatedGroups = distributionGroups
        .flatMap((node: any) => 
          node.children 
            ? node.children.filter((child: any) => selectedGroupIds.includes(child.key)) 
            : selectedGroupIds.includes(node.key) ? [node] : []
        )
        .map((g: any) => ({
  id: g.key,
  name: g.name,
  category: findCategoryName(distributionGroups, g.key),
  comment: ""
}));
      setSelectedGroups(updatedGroups);
      onChange(updatedGroups);
      validateRequiredFields();
  };

  const handleRemoveGroup = (id: number) => {
    const newGroups = selectedGroups.filter((i) => i.id !== id);
    setSelectedGroups(newGroups);
    onChange(newGroups);
  };

  const onEdit = (index: number) => {
    setExpandedSections((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) newSet.delete(index);
      else newSet.add(index);
      return newSet;
    });
  };

  const groupData = (data: any[]) => {
    const grouped: Record<string, { categoryName: string; groups: any[] }> = {};

    data.forEach((item) => {
        if (item.categoryId) {
            if (!grouped[item.categoryId]) {
                grouped[item.categoryId] = { categoryName: item.categoryName, groups: [] };
            }
            grouped[item.categoryId].groups.push(item);
        }
    });

    const groupedItems = Object.values(grouped).map((category) => ({
        key: category.categoryName,
        name: `${category.categoryName} (${category.groups.length})`,
        children: category.groups.map((group) => ({
            key: group.id,
            name: group.name
        }))
    }));

    const ungroupedItems = data.filter((item) => !item.categoryId).map((item) => ({
        key: item.id,
        name: item.name
    }));

    return [...groupedItems, ...ungroupedItems];
};
const handleSectionExpandedChange = () => {
  setExpandedSectionKey((prevKey:any) => prevKey.has("groupsSection") ? new Set() : new Set(["groupsSection"]));
};

//    useEffect(() => {
//   if (expandedSectionKey?.has?.("groupsSection")) {
//     setTimeout(() => {
//       const treeContainer = document.querySelector('#contactDGroups');
//       if (treeContainer) {
//         // Look for any focusable element within the tree
//         const focusableEl = treeContainer.querySelector(
//           '[role="row"], input, button, [tabindex="0"]'
//         );
//         console.log("focusable", focusableEl);
//         if (focusableEl instanceof HTMLElement) {
//           focusableEl.focus();
//         }
//       }
//     }, 100);
//   }
// }, [expandedSectionKey]);

useEffect(() => {
  if (expandedSectionKey?.has?.("groupsSection")) {
    setTimeout(() => {
      const focusableEl = document.querySelector('#contactDGroups [role="row"] input[type="checkbox"]');
      console.log("focusable", focusableEl);
      if (focusableEl instanceof HTMLElement) {
        focusableEl.focus();
      }
    }, 100);
  }
}, [expandedSectionKey]);

const handleConfirm = ()=>{
  const errors:any = {};
    if(fieldConfig?.DGROUP?.required && data.length === 0){
      ToastQueue.negative("Group required",{timeout:5000})
      setValidationStatus((prev:any) => ({ ...prev, ['groupsSection']: false }));
      return
    }
    setValidationStatus((prev:any) => ({ ...prev, ['groupsSection']: true }));
    setExpandedSectionKey(new Set(['commentSection']))
}

const validateRequiredFields = ()=>{
  const errors:any = {};
    if(fieldConfig?.DGROUP?.required && data.length === 0){
      setValidationStatus((prev:any) => ({ ...prev, ['groupsSection']: false }));
      return
    }
    setValidationStatus((prev:any) => ({ ...prev, ['groupsSection']: true }));
}

const groupByCategory = (groups: any[]) => {
  const grouped: Record<string, any[]> = {};
  const uncategorized: any[] = [];

  groups.forEach((group) => {
    const category = group.category || "";
    if (category === "") {
      uncategorized.push(group);
    } else {
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(group);
    }
  });

  // Sort grouped keys alphabetically (optional)
  const sortedKeys = Object.keys(grouped).sort();

  // Rebuild grouped object with uncategorized last
  const finalGrouped: Record<string, any[]> = {};
  for (const key of sortedKeys) {
    finalGrouped[key] = grouped[key];
  }
  if (uncategorized.length > 0) {
    finalGrouped[""] = uncategorized;
  }

  return finalGrouped;
};


const groupedTags = groupByCategory(selectedGroups || data);
const getBadgeClass = (index:number)=>{
    if(index === 0){
      return styles.blueBadge
    }else if(index === 1){
      return styles.purpleBadge
    }else if(index === 2){
      return styles.orangeBadge
    }else{
      return styles.redBadge;
    }
}

const getBadgeIconClass = (index:number)=>{
    if(index === 0){
      return styles.icon_close_blue
    }else if(index === 1){
      return styles.icon_close_purple
    }else if(index === 2){
      return styles.icon_close_orange
    }else{
      return styles.icon_close_red
    }
}

  return (
      <Accordion isQuiet expandedKeys={expandedSectionKey} onExpandedChange={handleSectionExpandedChange}>
      <Disclosure id="groupsSection"> 
        <DisclosureTitle>
          <Flex justifyContent="space-between" alignItems="center" width="100%">
            <View><span>{_tt(`groups`)}</span><span style={{color:'#B0BEC5',fontFamily:'Adobe Clean'}}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
            {validationStatus.groupsSection ? <Check size={20} color="#1976D2" /> :<ExclamationTriangle size={20} color="#FF9800" />}
          </Flex>
        </DisclosureTitle>
        <DisclosurePanel>
        <Divider size='M' UNSAFE_style={{marginBottom:10}}/>
        <Flex direction="column" gap="size-100" width="100%">
        {Object.entries(groupedTags).map(([category, groups], groupIndex) => (
         <div key={category} style={{ marginBottom: "1rem" }}>
    <strong> {category}</strong>
    <div style={{ marginTop: "0.5rem", display: "flex", gap: "8px", flexWrap: "wrap",backgroundColor:'#fff',borderRadius:'10px',padding:'8px' }}>
      {groups.map((item) => (
            <Badge
          key={item.id}
          style={{display: "div", alignItems: "center",}}
          className={getBadgeClass(groupIndex)}
        >
          <span >{item.name}</span>
          <Button
            variant="link"
            size='sm'
            onClick={() => handleRemoveGroup(item.id)}
            style={{ marginLeft: "8px", padding: 0,}}
            className={getBadgeIconClass(groupIndex)}
          >
            <CloseIcon size={12} />
          </Button>
        </Badge>
      ))}
    </div>
  </div>
        ))}
        {data.length > 0 && 
          <Divider aria-label="" />
        }
        <TreeView 
        id="contactDGroups"
        aria-label="Distribution Groups"
        selectionMode="multiple" 
        //defaultExpandedKeys={["Campaigns", "Internal", "Newsletters"]}
        selectedKeys={data.map(group => group.id ? group.id : '')}
        onSelectionChange={handleGroupSelection}
        >
      {distributionGroups && distributionGroups.map((node:any) =>
        node.children ? (
          <TreeViewItem key={node.key} id={node.key} textValue={node.name}>
            <TreeViewItemContent>
              <Text>{node.name}</Text>
            </TreeViewItemContent>
            {node.children.map((child:any) => (
              <TreeViewItem key={child.key} id={child.key} textValue={child.name}>
                <TreeViewItemContent>
                  <Text>{child.name}</Text>
                </TreeViewItemContent>
              </TreeViewItem>
            ))}
          </TreeViewItem>
        ) : (
          <TreeViewItem key={node.key} id={node.key} textValue={node.name}>
            <TreeViewItemContent>
              <Text>{node.name}</Text>
            </TreeViewItemContent>
          </TreeViewItem>
        )
      )}
    </TreeView>
    <Flex justifyContent={'end'} marginTop={10} gap={'size-50'}>
                        <View marginTop={12}>
                          <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{color:'#1976D2',padding:10}}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton> {/*active:#1976D2, disabled:#B0BEC5*/}
                        </View>
                      </Flex>
      </Flex>
      <Divider size='M' UNSAFE_style={{marginTop:10}}/>
        </DisclosurePanel>
        </Disclosure>
        </Accordion>
  );
};

export default DistributedGroupsSection;
